import React, { useState, useEffect } from 'react';
import { useMetamask } from "../../Scripts/UseMetamask";
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import Logo from '../../images/GunxLogo.png';
import {
  MobileIcon,
  Nav,
  NavLogo,
  NavLogoImg,
  NavbarContainer,
  NavItem,
  NavLinks,
  NavMenu,
  NavBtn,
  NavBtnConnect,
  NavBtnConnected
} from './NavbarElements';

const Navbar = ({ toggle }) => {
  const {connect, account} = useMetamask();
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav>
          <NavbarContainer>
            <NavLogo>
              <NavLogoImg src={Logo} />
            </NavLogo>
            <MobileIcon onClick={toggle}>
              <FaBars />
            </MobileIcon>
            <NavMenu>
            <NavItem>
            <NavLinks
                  scrollNav={scrollNav}
                  target= '_blank'
                  href= 'https://twitter.com/spearheadirl'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  Twitter
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  scrollNav={scrollNav}
                  target= '_blank'
                  href= 'https://discord.gg/tH7KR4Nn'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  Discord
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  scrollNav={scrollNav}
                  target= '_blank'
                  href='https://nftkey.app/collections/gutterpunx/'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  VIEW NFTS
                </NavLinks>
              </NavItem>
            </NavMenu>
            <NavBtn>
              {account ? (
                <NavBtnConnected>Connected</NavBtnConnected>
                ):(
                <NavBtnConnect scrollNav={scrollNav} onClick={ connect }>Connect</NavBtnConnect>
              )}
            </NavBtn>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
